import React from 'react'
// import { FormattedMessage } from 'react-intl'
import messages from './messages'
// import classes from './styles.module.scss'
import { Drawer } from 'antd'
import { Flex } from 'antd-mobile'
import { createForm } from 'rc-form'
import { intl, recordCountlyEvent } from 'utils'
import classes from './styles.module.scss'
import { Route, Switch } from 'react-router-dom'
import _ from 'lodash'
import CardPay from 'components/PaymentMethods/CardPay'
import { NavigatorWithQS } from 'utils/navigateWithQS'
import AddNewCard from 'components/PaymentMethods/AddNewCard'
import { LoginDrawer, MessagePay, WingBlank } from 'components'
import { DrawerHeader } from './DrawerHeader'

function getCardMethodParams(data) {
  // eslint-disable-next-line no-unused-vars
  const cardData = _.filter(data, { tabType:'PAY_METHODS' }, [])
  // eslint-disable-next-line no-unused-vars
  for (const item of cardData) {
    const cardList = _.filter(
      item.payMethods,
      {
        type: 'PAYPAGE_CARD_PAY',
      },
      []
    )

    const canAddCard = _.filter(
      item.payMethods,
      {
        type: 'CARD_TOKEN',
      },
      []
    )
    const cardItem = item.tabType === 'PAY_METHODS' && item
    return { cardList, canAddCard, cardItem }
  }
}

class MobilePaymentContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
    }
    const { history, location } = props
    this.navigateWithQS = NavigatorWithQS.getInstance(history, location)
  }

  componentDidMount() {}
  get modalTitle() {
    const { location } = this.props
    switch (location.pathname) {
      case '/pay-page/main/mobile-payment-container/message-pay':
        return messages.MesagePay
      default:
        return messages.BankCard
    }
  }

  render() {
    const { actions, submit, loading, optAddCardItems, pageName, data, siteConfig, saveCard } = this.props
    const { canAddCard, cardList, cardItem } = getCardMethodParams(data) ?? {}
    //  const { drawerStyle } = this.state

    return (
      <Drawer
        height='80vh'
        zIndex={99}
        maskClosable={false}
        style={{ transform: undefined }}
        placement='bottom'
        visible
        closable={false}
        className={classes.payPageMainMobileMobilePaymentContainer}
      >
        <Flex direction='column' align='stretch' className={classes.scrollFormContainer}>
          <WingBlank>
            <DrawerHeader
              title={intl().formatMessage(this.modalTitle)}
              onClickLeft={() => this.navigateWithQS.back()}
              showLeft
              onClickRight={() => this.navigateWithQS.replace('/pay-page/main')}
            />
          </WingBlank>

          <Switch>
            <Route
              path='/pay-page/main/mobile-payment-container/card-pay'
              render={() => (
                <CardPay
                  {...cardItem}
                  actions={actions}
                  submit={submit}
                  loading={loading}
                  optAddCardItems={optAddCardItems}
                  cardList={cardList}
                  canAddCard={!!canAddCard.length}
                  pageName={pageName}
                />
              )}
            />
            <Route
              path='/pay-page/main/mobile-payment-container/add-new-card'
              render={() => (
                <AddNewCard
                  {...cardItem}
                  submit={submit}
                  loading={loading}
                  optAddCardItems={[...optAddCardItems, siteConfig.loginToken && 'saveCard']}
                  pageName={pageName}
                  saveCard={saveCard}
                />
              )}
            />
            <Route path='/pay-page/main/mobile-payment-container/login'>
              <LoginDrawer
                title={intl().formatMessage(messages.UseMyHistory)}
                btnText={intl().formatMessage(messages.BtnText)}
                onChange={(LoginDrawerVisible) => {
                  pageName &&
                    recordCountlyEvent({
                      page_name: pageName,
                      event_name: 'click',
                      element_name: 'close_login_popup',
                    })
                  this.setState({ LoginDrawerVisible })
                }}
                type='LOGIN'
              />
            </Route>
            <Route path='/pay-page/main/mobile-payment-container/message-pay'>
              <MessagePay submit={submit} loading={loading} pageName={pageName} />
            </Route>
          </Switch>
        </Flex>
      </Drawer>
    )
  }
}

export default createForm()(MobilePaymentContainer)
